import type { ClickstreamPayload } from './types';
import { defineTracker, getClickstreamWriteKey } from '@zg-rentals/rentals-analytics';
import { event } from '@zillow/universal-analytics';

// the SDK merges per-event options over its init options, but the published types omit `writeKey`
type EventOptions = NonNullable<Parameters<typeof event>[1]> & { writeKey?: string };

export const tracker = defineTracker<ClickstreamPayload<Record<string, unknown>>>((payload) => {
  const modifiedPayload = {
    ...payload,
    envelope: {
      ...payload.envelope,
      // add this here so every event definition in app code doesn't need to
      event_client_start_dtm: new Date().toISOString(),
    },
  };

  const writeKey = getClickstreamWriteKey();
  const options: EventOptions = writeKey ? { writeKey } : {};

  event(modifiedPayload, options);
});
